import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteEnthusiast = (props) => {
  const { oid, title } = props.data

  const handleOk = () => {
    axios.post('/admin/content/enthusiast/delete', { 
      enthusiast_oid: oid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('删除成功！')
          props.isCancel()
          props.getEnthusiastData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="删除达人"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okType='danger'
      okText='删除'>

      <p>正在将达人
        <span style={{color: '#005dff'}}>《{title}》</span>
        从列表中移除，此操作不可逆，是否确认删除？
      </p>
    </Modal>
  )
}

export default DeleteEnthusiast
